import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/internal/Subscription';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-turns-desk-capacity-card',
  templateUrl: './turns-desk-capacity-card.component.html',
  styleUrls: ['./turns-desk-capacity-card.component.scss']
})
export class TurnsDeskCapacityCardComponent implements OnInit, OnChanges {

  @Input() desk;
  basicDataForm = new FormGroup({
    capacity: new FormControl(null, Validators.required)
  });
  updateDeskUpdateCapacitySubscription: Subscription;

  constructor(private snackbarService: SnackBarService,
              private desksTurnsService: DesksTurnsService) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.desk) {
      this.resetForm();
    }
  }

  public inputChange() {
    if (this.basicDataForm.get('capacity').dirty && this.basicDataForm.get('capacity').valid) {
        this.submitForm();
    } else {
      this.resetForm();
    }
  }

  public submitForm() {
    this.updateDeskUpdateCapacitySubscription = this.desksTurnsService.updateDeskCapacity(this.desk.InternalId, this.basicDataForm.get('capacity').value).subscribe(
      (res) => {
        this.snackbarService.open('turns-page.snackbar messages.update desk success', 'success');
        this.desksTurnsService.refreshDesk();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private resetForm() {
    this.basicDataForm.patchValue({
      capacity: this.desk.Capacity
    });
  }
}
